import React from "react"
import { IconColorsType } from "../"
import { camelize } from "../../utils"
import cx from "classnames"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "slider"
const SliderIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    }
  )
  const wrap = (content: React.ReactNode) => (
    <span className={computedClassName}>{content}</span>
  )
  return wrap(
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.002 7A.995.995 0 0 0 2 8c0 .556.449 1 1.002 1h6.124a4.007 4.007 0 0 1 0-2H3.002Zm17.995 0A.999.999 0 0 1 22 8c0 .552-.44 1-1.003 1h-4.123a4.01 4.01 0 0 0 0-2h4.123ZM4.127 15H3.002A.995.995 0 0 0 2 16c0 .556.449 1 1.002 1h1.124a4.007 4.007 0 0 1 0-2Zm16.871 0A.999.999 0 0 1 22 16c0 .552-.44 1-1.003 1h-9.123a4.01 4.01 0 0 0 0-2h9.123ZM13 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm-5 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
      />
    </svg>
  )
}
export default SliderIcon
